const cls = "h-6 md:h-7 w-auto shrink-0";
const textCls = `${cls} flex items-center font-['DM_Sans'] font-semibold text-[15px] md:text-[17px] tracking-tight whitespace-nowrap`;

export function BenzingaLogo() {
  return <span className={textCls}>Benzinga</span>;
}

export function BinanceLogo() {
  return (
    <svg
      className={cls}
      viewBox="0 0 223 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1364 23.3264L5.11303 28.3497L0 23.3264L5.11303 18.2133L10.1364 23.3264ZM22.4256 11.0372L31.1267 19.7383L36.2397 14.6252L22.4256 0.900787L8.70113 14.6252L13.8142 19.7383L22.4256 11.0372ZM39.7381 18.2133L34.7148 23.3264L39.8278 28.4394L44.8512 23.3264L39.7381 18.2133ZM22.4256 35.6156L13.7245 26.9145L8.61142 32.0275L22.4256 45.752L36.15 32.0275L31.1267 26.9145L22.4256 35.6156ZM22.4256 28.3497L27.5386 23.2367L22.4256 18.2133L17.3125 23.3264L22.4256 28.3497ZM75.8882 28.8879C75.8882 25.4792 74.0941 23.8646 71.3134 22.7882C73.1074 21.8014 74.5426 20.2765 74.5426 17.4957V17.406C74.5426 13.5488 71.4031 11.0372 66.4694 11.0372H54.9875V35.6156H66.6488C72.2104 35.6156 75.8882 33.373 75.8882 28.8879ZM69.0708 18.3927C69.0708 20.2765 67.5459 20.9941 65.2136 20.9941H60.1903V15.7914H65.5724C67.815 15.7914 69.0708 16.6884 69.0708 18.3927ZM70.506 28.1703C70.506 29.9643 69.0708 30.8614 66.7385 30.8614H60.28V25.4792H66.5591C69.2502 25.4792 70.506 26.466 70.506 28.1703ZM87.1907 35.6156V11.0372H81.7188V35.6156H87.1907ZM116.254 35.6156V11.0372H110.872V26.1968L99.3902 11.0372H94.3669V35.6156H99.749V20.0074L111.679 35.6156H116.254ZM146.215 35.6156L135.63 10.8577H130.607L120.022 35.6156H125.583L127.826 30.054H138.231L140.474 35.6156H146.215ZM136.348 25.2998H129.799L133.118 17.3163L136.348 25.2998ZM172.049 35.6156V11.0372H166.667V26.1968L155.185 11.0372H150.162V35.6156H155.544V20.0074L167.474 35.6156H172.049ZM199.946 31.6687L196.448 28.1703C194.475 29.9643 192.77 31.0408 189.99 31.0408C185.774 31.0408 182.813 27.5424 182.813 23.3264V23.2367C182.813 19.0207 185.774 15.612 189.99 15.612C192.412 15.612 194.385 16.6884 196.269 18.3927L199.767 14.4458C197.525 12.2033 194.744 10.6783 190.079 10.6783C182.544 10.6783 177.252 16.4193 177.252 23.4161V23.3264C177.252 30.4129 182.634 35.9744 189.9 35.9744C194.564 36.0641 197.435 34.3598 199.946 31.6687ZM223 35.6156V30.7717H209.634V25.5689H221.206V20.725H209.634V15.7017H222.821V10.8577H204.252V35.4362L223 35.6156Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ManilaTimesLogo() {
  return (
    <span
      className={textCls}
      style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}
    >
      The Manila Times
    </span>
  );
}

export function BusinessInsidersLogo() {
  return <span className={textCls}>Business Insider</span>;
}

export function CoinMarketCapLogo() {
  return (
    <span
      className={cls}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "nowrap",
      }}
    >
      <svg
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: 22, height: 22 }}
      >
        <path
          d="M42.663 21.6675V21.5835C42.621 9.699 33.048 0 21.3315 0C9.615 0 0 9.699 0 21.6675C0 33.6375 9.5715 43.317 21.3315 43.317C26.7278 43.3207 31.9177 41.2436 35.8215 37.518C36.206 37.1667 36.4352 36.6771 36.4587 36.1568C36.4822 35.6365 36.298 35.1282 35.9468 34.7438C35.5955 34.3593 35.1058 34.13 34.5856 34.1066C34.0653 34.0831 33.557 34.2672 33.1725 34.6185L33.1305 34.6605C31.4461 36.2618 29.4555 37.5062 27.2782 38.319C25.1009 39.1318 22.7819 39.4962 20.4602 39.3905C18.1386 39.2847 15.8622 38.7109 13.7679 37.7034C11.6735 36.696 9.80431 35.2758 8.2725 33.528L17.385 18.915V25.677C17.385 28.908 18.645 29.9595 19.704 30.2535C20.763 30.5475 22.3515 30.3345 24.072 27.606L29.0715 19.488C29.205 19.251 29.3595 19.026 29.5305 18.8145V22.932C29.5305 25.9545 30.7485 28.3905 32.847 29.565C33.8157 30.0925 34.9092 30.3477 36.0113 30.3036C37.1134 30.2595 38.183 29.9177 39.1065 29.3145C41.5305 27.741 42.8325 24.9855 42.663 21.6675ZM37.119 25.92C36.7824 26.1519 36.3899 26.2896 35.9822 26.3189C35.5744 26.3482 35.1663 26.2679 34.8 26.0865C33.96 25.584 33.4545 24.4515 33.4545 22.8975V18.138C33.4545 15.873 32.5725 14.2335 31.062 13.8165C28.4985 13.0425 26.5695 16.209 25.854 17.385L21.3315 24.648V15.705C21.2895 13.6485 20.616 12.4305 19.356 12.051C18.516 11.8005 17.256 11.928 16.0395 13.776L5.919 29.9835C4.57264 27.418 3.86706 24.5648 3.8625 21.6675C3.8625 11.883 11.7135 3.9465 21.3315 3.9465C30.9495 3.9465 38.8005 11.883 38.8005 21.6675V21.753C38.901 23.64 38.295 25.155 37.1205 25.908L37.119 25.92Z"
          fill="currentColor"
        />
      </svg>
      <span className="font-['DM_Sans'] font-semibold text-[15px] md:text-[17px] tracking-tight">
        CoinMarketCap
      </span>
    </span>
  );
}

export function StreetInsiderLogo() {
  return <span className={textCls}>StreetInsider</span>;
}

export function BTCLogo() {
  return (
    <span
      className={cls}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "nowrap",
      }}
    >
      <svg
        viewBox="0 0 57 57"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: 22, height: 22 }}
      >
        <path
          d="M28.3203 56.6526C43.9612 56.6526 56.6407 43.9705 56.6407 28.3263C56.6407 12.6821 43.9612 0 28.3203 0C12.6795 0 0 12.6821 0 28.3263C0 43.9705 12.6795 56.6526 28.3203 56.6526Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.4013 16.2955C38.3287 17.7365 41.1577 19.8714 40.5091 23.9681C40.0183 26.9503 38.4556 28.4078 36.3438 28.9222C39.154 30.4952 40.5066 32.8828 39.0597 37.0708C37.2602 42.3234 33.2325 42.7998 27.8976 41.7823L26.5242 47.3258L23.4244 46.5576L24.7978 41.0141C24.4605 40.9243 24.1051 40.8416 23.7405 40.7566C23.2534 40.6433 22.7499 40.5261 22.2518 40.383L20.8784 45.9268L17.7843 45.16L19.1577 39.6162L12.9941 37.9376L14.5261 34.0178C14.5261 34.0178 16.8525 34.6577 16.8165 34.6175C17.6793 34.8274 18.1012 34.2246 18.2741 33.8025L20.4735 24.9155L22.0742 18.599C22.1433 17.9163 21.9295 17.0231 20.6688 16.6833C20.7546 16.633 18.3992 16.1208 18.3992 16.1208L19.317 12.406L25.6695 13.9804L27.0147 8.55029L30.215 9.34343L28.8697 14.7735C29.4919 14.9088 30.1 15.0661 30.7145 15.225L30.7148 15.2251C30.9164 15.2773 31.1189 15.3296 31.3228 15.3815L32.6681 9.95137L35.7819 10.7231L34.4013 16.2955ZM25.9093 25.0269C25.9577 25.0414 26.0095 25.057 26.0646 25.0735C27.9255 25.6328 33.4435 27.291 34.3729 23.5988C35.2384 20.0893 30.4579 19.0173 28.2367 18.5192C27.9744 18.4604 27.7477 18.4096 27.5703 18.3637L25.9093 25.0269ZM23.4606 35.974C23.3628 35.9449 23.2726 35.9182 23.1909 35.8942L24.8519 29.231C25.0481 29.2819 25.2964 29.3403 25.5834 29.4077C28.2019 30.023 34.0504 31.3974 33.1413 34.9265C32.2591 38.5911 25.7532 36.6561 23.4606 35.974Z"
          fill="black"
        />
      </svg>
      <span className="font-['DM_Sans'] font-semibold text-[15px] md:text-[17px] tracking-tight">
        Bitcoin.com
      </span>
    </span>
  );
}

export function APNewsLogo() {
  return <span className={textCls}>AP News</span>;
}

export function CryptoBriefingLogo() {
  return <span className={textCls}>Crypto Briefing</span>;
}

export function AnalyticsInsightLogo() {
  return <span className={textCls}>Analytics Insight</span>;
}

export function MPostLogo() {
  return <span className={textCls}>Mpost</span>;
}

export function InvestingComLogo() {
  return <span className={textCls}>Investing.com</span>;
}

export function CoinEditionLogo() {
  return <span className={textCls}>Coin Edition</span>;
}

export function TheNewsCryptoLogo() {
  return <span className={textCls}>TheNewsCrypto</span>;
}

export function TechBullionLogo() {
  return <span className={textCls}>TechBullion</span>;
}
